import React from 'react'
import {Card, styled} from '@mui/material';

const StyledCard = styled(Card)`
    border-radius: 20px;
    box-shadow: 4px 4px 10px 0 #00000044;
`;

const CardContainer = props=><StyledCard {...props}/>;

export default CardContainer;
